import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { EditUserProfileComponent } from './component/user profile/edit-user-profile/edit-user-profile.component';
import { AuthorizationGuard } from './service/auth-guard/authorization-guard.service';
import { UnassignedComponent } from './component/assigned-trips/unassigned/unassigned.component';
import { NewTripComponent } from './component/assigned-trips/new-trip/new-trip.component';
import { NotificationDetailsComponent } from './notification/notification-details/notification-details.component';
import { MemberListComponent } from './component/members/member-list/member-list.component';
import { CreateMemberComponent } from './component/members/create-member/create-member.component';
import { ZDatesComponent } from './component/z-dates/z-dates.component';
import { StandingOrdersV2Component } from './component/assigned-trips/standing-orders-v2/standing-orders-v2.component';
import { UserRoles } from './service/menu-service/menu.service';
import { UnAuthorizationGuard } from './service/non-auth-guard/unauthorization-guard.service';
import { StaffListComponent } from './component/staffs/staff-list/staff-list.component';
import { AddStaffComponent } from './component/staffs/add-staff/add-staff.component';
import { AuthTokenComponent } from './component/auth-token/auth-token.component';
import { OperationsComponent } from './component/operations/operations.component';
import { TutorialListComponent } from './component/tutorials/tutorial-list/tutorial-list.component';




const routes: Routes = [
  {
    path: 'login', component: SignInComponent, canActivate: [UnAuthorizationGuard]
  },

  { path: '', redirectTo: '/trips', pathMatch: 'full' },
  
  { path: 'auth-token/:token', component: AuthTokenComponent },
  {
    path: 'trips', component: UnassignedComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.CALL_CENTER_REP, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'operations', component: OperationsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.CALL_CENTER_REP, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'trips/new', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'trips/:id/edit', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'credentialing/staff', component: StaffListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/staff/add', component: AddStaffComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/staff/:id/edit', component: AddStaffComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'standing-orders', component: StandingOrdersV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.CALL_CENTER_REP, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'credentialing/members', component: MemberListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/members/add', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/members/:id/edit', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'profile', component: EditUserProfileComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.CALL_CENTER_REP, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },

  {
    path: 'notifications', component: NotificationDetailsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'academy', component: TutorialListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

 
  { path: '**', component: ZDatesComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
